import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<any> {
    const timestamp = new Date().getTime(); // Generate a unique timestamp
    return this.http.get(`/assets/config/config.json?t=${timestamp}`); // Append the timestamp as a query parameter
  }

  setConfig(config: any): void {
    this.config = config;
  }

  getConfig(): any {
    return this.config;
  }
}

